
import {
  defineComponent, onBeforeUnmount, PropType, ref,
} from 'vue'
import axios from 'axios'
import { useI18n } from 'vue-i18n'
import Timeout from '@/types/timeout.d'
import IconEye from '@/vue/icons/IconEye.vue'
import IconEyeSlash from '@/vue/icons/IconEyeSlash.vue'

export default defineComponent({
  name: 'AdminButtons',
  components: { IconEyeSlash, IconEye },
  props: {
    schedule: {
      type: Number as PropType<number>,
      required: true,
    },
    webinar: {
      type: Number as PropType<number>,
      required: true,
    },
    videoTiming: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { t } = useI18n()

    const buttons = ref([])
    let timeout: Timeout
    const getButtons = async () => {
      clearTimeout(timeout)
      buttons.value = await axios.get(`/buttons/${props.schedule}`, {
        params: {
          webinar: props.webinar,
          timing: props.videoTiming,
        },
      }).then(({ data }) => data).catch(() => [])
      timeout = setTimeout(getButtons, 1000)
    }
    onBeforeUnmount(() => clearTimeout(timeout))
    getButtons()

    const changeVisibility = async (id: number, visibility: boolean) => {
      await axios.post(`/buttons/${props.schedule}/visibility`, {
        id,
        visibility: !visibility,
      })
      await getButtons()
    }

    return {
      buttons,
      changeVisibility,
      t,
    }
  },
})
